import type React from 'react';

import type { IconProps } from 'types/icon';

const GiftBox: React.FC<IconProps> = ({
  size = '20',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M19 11.9492C18.8383 11.9821 18.6711 12 18.5 12H12.5V20H16.5C17.8807 20 19 18.8807 19 17.5V11.9492ZM5 17.5C5 18.8807 6.11929 20 7.5 20H11.5V12H5.5C5.3289 12 5.16174 11.9821 5 11.9492V17.5ZM20 9.5C20 8.67157 19.3284 8 18.5 8H12.5V11H18.5C18.774 11 19.0299 10.9271 19.25 10.7998C19.6995 10.5397 20 10.0545 20 9.5ZM4 9.5C4 10.0545 4.30045 10.5397 4.75 10.7998C4.97012 10.9271 5.22595 11 5.5 11H11.5V8H5.5C4.67157 8 4 8.67157 4 9.5ZM16.5 4.16699C16.5 3.52266 15.9773 3 15.333 3C13.7685 3.00018 12.5002 4.26846 12.5 5.83301V7H13.667C15.2315 6.99982 16.4998 5.73154 16.5 4.16699ZM7.5 4.16699C7.50018 5.73154 8.76846 6.99982 10.333 7H11.5V5.83301C11.4998 4.26846 10.2315 3.00018 8.66699 3C8.02266 3 7.5 3.52266 7.5 4.16699ZM17.5 4.16699C17.4999 5.28951 17.017 6.29899 16.248 7H18.5C19.8807 7 21 8.11929 21 9.5C21 10.3182 20.6062 11.0434 20 11.499V17.5C20 19.433 18.433 21 16.5 21H7.5C5.567 21 4 19.433 4 17.5V11.499C3.39381 11.0434 3 10.3182 3 9.5C3 8.11929 4.11929 7 5.5 7H7.75195C6.98297 6.29899 6.50009 5.28951 6.5 4.16699C6.5 2.97038 7.47038 2 8.66699 2C10.0954 2.00012 11.3406 2.78183 12 3.94043C12.6594 2.78183 13.9046 2.00012 15.333 2C16.5296 2 17.5 2.97038 17.5 4.16699Z"
        fill={color}
      />
    </svg>
  );
};

export default GiftBox;
